import React from "react";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import { AuthProvider, useAuth } from "./auth/session";
import PrivateRoute from "./auth/PrivateRoute";
import MainLayout from "./components/layout/MainLayout";
import Dashboard from "./pages/Dashboard";
import SignIn from "./pages/SignIn";
import SystemUsers from "./pages/SystemUsers";
import BankAccounts from "./pages/BankAccounts";
import AuditLogs from "./pages/AuditLogs";
import Transactions from "./pages/Transactions";
import Reconciliations from "./pages/Reconciliations";
import IpAccessRules from "./pages/IpAccessRules";
import MyAccount from "./pages/MyAccount";
import Devices from "./pages/Devices";
import GeneralSettings from "./pages/GeneralSettings";

function DevicesRoute() {
  const { user } = useAuth();
  return <Devices currentUser={user} />;
}

function UsersRoute() {
  const { user } = useAuth();
  return <SystemUsers currentUser={user} />;
}

function AccountsRoute() {
  const { user } = useAuth();
  return <BankAccounts currentUser={user} />;
}

function TransactionsRoute() {
  const { user } = useAuth();
  return <Transactions currentUser={user} />;
}

function ReconciliationsRoute() {
  const { user } = useAuth();
  return <Reconciliations currentUser={user} />;
}

function MyAccountRoute() {
  const { user } = useAuth();
  return <MyAccount currentUser={user} />;
}

export function AppRoutes() {
  return (
    <Switch>
      <Route exact path="/sign-in"><SignIn /></Route>
      <PrivateRoute exact path="/dashboard" permission="dashboard:view">
        <MainLayout><Dashboard /></MainLayout>
      </PrivateRoute>
      <PrivateRoute exact path="/system/users" permission="users:view">
        <MainLayout><UsersRoute /></MainLayout>
      </PrivateRoute>
      <PrivateRoute exact path="/system/ip-access" permission="ip-access:view">
        <MainLayout><IpAccessRules /></MainLayout>
      </PrivateRoute>
      <PrivateRoute exact path="/system/settings" permission="categories:edit">
        <MainLayout><GeneralSettings /></MainLayout>
      </PrivateRoute>
      <PrivateRoute exact path="/account/me">
        <MainLayout><MyAccountRoute /></MainLayout>
      </PrivateRoute>
      <PrivateRoute exact path="/bank-accounts" permission="accounts:view">
        <MainLayout><AccountsRoute /></MainLayout>
      </PrivateRoute>
      <PrivateRoute exact path="/transactions" permission="transactions:view">
        <MainLayout><TransactionsRoute /></MainLayout>
      </PrivateRoute>
      <PrivateRoute exact path="/devices" permission="devices:view">
        <MainLayout><DevicesRoute /></MainLayout>
      </PrivateRoute>
      <PrivateRoute exact path="/reconciliations" permission="reconciliations:view">
        <MainLayout><ReconciliationsRoute /></MainLayout>
      </PrivateRoute>
      <PrivateRoute exact path="/system/audit-logs" permission="audit:view">
        <MainLayout><AuditLogs /></MainLayout>
      </PrivateRoute>
      <Redirect to="/dashboard" />
    </Switch>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
